import React from 'react';

const Asterisk = () => <span>*</span>;

export default Asterisk;
